export default __webpack_public_path__ + "static/media/signature_11.4021f40a.png";